// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1vZfX","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1XKr3"};